/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { ControllerResponse__enabled_boolean__ } from '../models/ControllerResponse__enabled_boolean__';
import type { ControllerResponse_AdminApiUsage_Array_ } from '../models/ControllerResponse_AdminApiUsage_Array_';
import type { ControllerResponse_AdminInPortfolioStats_Array_ } from '../models/ControllerResponse_AdminInPortfolioStats_Array_';
import type { ControllerResponse_AdminUser_ } from '../models/ControllerResponse_AdminUser_';
import type { ControllerResponse_AdminUser_Array_ } from '../models/ControllerResponse_AdminUser_Array_';
import type { ControllerResponse_boolean_ } from '../models/ControllerResponse_boolean_';
import type { ControllerResponse_DatasetAttributes_ } from '../models/ControllerResponse_DatasetAttributes_';
import type { ControllerResponse_DebugProperty_Array_ } from '../models/ControllerResponse_DebugProperty_Array_';
import type { ControllerResponse_GroupAttributes_Array_ } from '../models/ControllerResponse_GroupAttributes_Array_';
import type { ControllerResponse_MarketAnalyticsSubscriptionAttributes_ } from '../models/ControllerResponse_MarketAnalyticsSubscriptionAttributes_';
import type { ControllerResponse_null_ } from '../models/ControllerResponse_null_';
import type { ControllerResponse_number_or_null_ } from '../models/ControllerResponse_number_or_null_';
import type { ControllerResponse_OrganizationAttributes_and__given_name_string_family_name_string_email_string__Array_ } from '../models/ControllerResponse_OrganizationAttributes_and__given_name_string_family_name_string_email_string__Array_';
import type { ControllerResponse_OrganizationAttributes_or_null_ } from '../models/ControllerResponse_OrganizationAttributes_or_null_';
import type { ControllerResponse_PropertyReportSubscriptionAttributes_ } from '../models/ControllerResponse_PropertyReportSubscriptionAttributes_';
import type { ControllerResponse_PropertyReportSubscriptionAttributes_Array_ } from '../models/ControllerResponse_PropertyReportSubscriptionAttributes_Array_';
import type { ControllerResponse_RentRollAttributes_ } from '../models/ControllerResponse_RentRollAttributes_';
import type { ControllerResponse_ReportResult_ } from '../models/ControllerResponse_ReportResult_';
import type { ControllerResponse_SimpleStripeUser_Array_ } from '../models/ControllerResponse_SimpleStripeUser_Array_';
import type { ControllerResponse_Subscription_ } from '../models/ControllerResponse_Subscription_';
import type { ControllerResponse_Subscription_Array_ } from '../models/ControllerResponse_Subscription_Array_';
import type { ControllerResponse_Subscription_or_null_ } from '../models/ControllerResponse_Subscription_or_null_';
import type { ControllerResponse_TemplateAIAttributes_ } from '../models/ControllerResponse_TemplateAIAttributes_';
import type { ControllerResponse_TemplateAIAttributes_Array_ } from '../models/ControllerResponse_TemplateAIAttributes_Array_';
import type { ControllerResponse_UserAttributes_Array_ } from '../models/ControllerResponse_UserAttributes_Array_';
import type { CreateGroupAttributes } from '../models/CreateGroupAttributes';
import type { DatasetPayload } from '../models/DatasetPayload';
import type { GroupAttributes } from '../models/GroupAttributes';
import type { NewClient } from '../models/NewClient';
import type { NewUser } from '../models/NewUser';
import type { Omit_OrganizationAttributes_id_ } from '../models/Omit_OrganizationAttributes_id_';
import type { Pick_UserAttributes_id_or_email_or_created_on_or_organization_id_or_given_name_or_family_name_or_picture_or_group_id_ } from '../models/Pick_UserAttributes_id_or_email_or_created_on_or_organization_id_or_given_name_or_family_name_or_picture_or_group_id_';
import type { UpdateGroupAttributes } from '../models/UpdateGroupAttributes';
import type { CancelablePromise } from '../core/CancelablePromise';
import type { BaseHttpRequest } from '../core/BaseHttpRequest';
export class AdminService {
    constructor(public readonly httpRequest: BaseHttpRequest) {}
    /**
     * @returns ControllerResponse_AdminUser_Array_ Ok
     * @throws ApiError
     */
    public getAllUsers(): CancelablePromise<ControllerResponse_AdminUser_Array_> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/admin/users',
        });
    }
    /**
     * @param requestBody
     * @returns ControllerResponse_AdminUser_ Ok
     * @throws ApiError
     */
    public createNewUser(
        requestBody: NewUser,
    ): CancelablePromise<ControllerResponse_AdminUser_> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/admin/users',
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * @returns ControllerResponse_SimpleStripeUser_Array_ Ok
     * @throws ApiError
     */
    public getAllSimpleStripeUsers(): CancelablePromise<ControllerResponse_SimpleStripeUser_Array_> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/admin/stripe_users',
        });
    }
    /**
     * @param productId
     * @returns ControllerResponse_OrganizationAttributes_and__given_name_string_family_name_string_email_string__Array_ Ok
     * @throws ApiError
     */
    public getOrganizationsByProductId(
        productId?: string,
    ): CancelablePromise<ControllerResponse_OrganizationAttributes_and__given_name_string_family_name_string_email_string__Array_> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/admin/organizations',
            query: {
                'productId': productId,
            },
        });
    }
    /**
     * @param reportId
     * @returns ControllerResponse_PropertyReportSubscriptionAttributes_ Ok
     * @throws ApiError
     */
    public copyPropertyReport(
        reportId: number,
    ): CancelablePromise<ControllerResponse_PropertyReportSubscriptionAttributes_> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/admin/reports/{reportId}/copy',
            path: {
                'reportId': reportId,
            },
        });
    }
    /**
     * @param reportId
     * @returns ControllerResponse_MarketAnalyticsSubscriptionAttributes_ Ok
     * @throws ApiError
     */
    public copyMarketAnalytics(
        reportId: number,
    ): CancelablePromise<ControllerResponse_MarketAnalyticsSubscriptionAttributes_> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/admin/market_analytics/{reportId}/copy',
            path: {
                'reportId': reportId,
            },
        });
    }
    /**
     * @param datasetId
     * @returns ControllerResponse_DatasetAttributes_ Created
     * @throws ApiError
     */
    public copyDataset(
        datasetId: number,
    ): CancelablePromise<ControllerResponse_DatasetAttributes_> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/admin/datasets/{datasetId}/copy',
            path: {
                'datasetId': datasetId,
            },
        });
    }
    /**
     * @param rentRollId
     * @returns ControllerResponse_RentRollAttributes_ Created
     * @throws ApiError
     */
    public copyRentRoll(
        rentRollId: number,
    ): CancelablePromise<ControllerResponse_RentRollAttributes_> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/admin/rent_rolls/{rentRollId}/copy',
            path: {
                'rentRollId': rentRollId,
            },
        });
    }
    /**
     * @param reportId
     * @returns ControllerResponse_ReportResult_ Ok
     * @throws ApiError
     */
    public getReport(
        reportId: number,
    ): CancelablePromise<ControllerResponse_ReportResult_> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/admin/reports/{reportId}',
            path: {
                'reportId': reportId,
            },
        });
    }
    /**
     * @param userId
     * @returns ControllerResponse_UserAttributes_Array_ Ok
     * @throws ApiError
     */
    public listOrganizationMembers(
        userId: string,
    ): CancelablePromise<ControllerResponse_UserAttributes_Array_> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/admin/organization_members/{userId}',
            path: {
                'userId': userId,
            },
        });
    }
    /**
     * @param organizationId
     * @param userId
     * @returns ControllerResponse_PropertyReportSubscriptionAttributes_Array_ Ok
     * @throws ApiError
     */
    public listOrganizationReports(
        organizationId: number,
        userId: string,
    ): CancelablePromise<ControllerResponse_PropertyReportSubscriptionAttributes_Array_> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/admin/organization_reports/{organizationId}/{userId}',
            path: {
                'organizationId': organizationId,
                'userId': userId,
            },
        });
    }
    /**
     * @param userId
     * @param requestBody
     * @returns ControllerResponse_null_ Ok
     * @throws ApiError
     */
    public removeFromOrganization(
        userId: string,
        requestBody: {
            transfer_user_id?: string;
            user_id: string;
        },
    ): CancelablePromise<ControllerResponse_null_> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/admin/remove_from_organization/{userId}',
            path: {
                'userId': userId,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * @param userId
     * @returns ControllerResponse_OrganizationAttributes_or_null_ Ok
     * @throws ApiError
     */
    public getOrganization(
        userId: string,
    ): CancelablePromise<ControllerResponse_OrganizationAttributes_or_null_> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/admin/organization/{userId}',
            path: {
                'userId': userId,
            },
        });
    }
    /**
     * @param userId
     * @param id
     * @param requestBody
     * @returns ControllerResponse_OrganizationAttributes_or_null_ Ok
     * @throws ApiError
     */
    public patchOrganization(
        userId: string,
        id: number,
        requestBody: Omit_OrganizationAttributes_id_,
    ): CancelablePromise<ControllerResponse_OrganizationAttributes_or_null_> {
        return this.httpRequest.request({
            method: 'PATCH',
            url: '/admin/organization/{userId}',
            path: {
                'userId': userId,
            },
            query: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * @param id
     * @returns ControllerResponse_OrganizationAttributes_or_null_ Ok
     * @throws ApiError
     */
    public pauseOrganization(
        id: number,
    ): CancelablePromise<ControllerResponse_OrganizationAttributes_or_null_> {
        return this.httpRequest.request({
            method: 'PATCH',
            url: '/admin/pause_organization',
            query: {
                'id': id,
            },
        });
    }
    /**
     * @param userId
     * @param extension
     * @returns any Ok
     * @throws ApiError
     */
    public extendLastSub(
        userId: string,
        extension: number,
    ): CancelablePromise<{
        data: number | null;
    }> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/admin/organization/{userId}/extend_last_subscription',
            path: {
                'userId': userId,
            },
            query: {
                'extension': extension,
            },
        });
    }
    /**
     * @param subscriptionId
     * @param trialEnd
     * @returns ControllerResponse_Subscription_ Ok
     * @throws ApiError
     */
    public updateTrialEnd(
        subscriptionId: string,
        trialEnd: string,
    ): CancelablePromise<ControllerResponse_Subscription_> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/admin/subscriptions/{subscriptionId}/update_trial_end',
            path: {
                'subscriptionId': subscriptionId,
            },
            query: {
                'trialEnd': trialEnd,
            },
        });
    }
    /**
     * @param userId
     * @param requestBody
     * @returns ControllerResponse_OrganizationAttributes_or_null_ Ok
     * @throws ApiError
     */
    public invitePeople(
        userId: string,
        requestBody: {
            emails: Array<string>;
        },
    ): CancelablePromise<ControllerResponse_OrganizationAttributes_or_null_> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/admin/invite_people/{userId}',
            path: {
                'userId': userId,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * @param userId
     * @param email
     * @returns ControllerResponse_number_or_null_ Ok
     * @throws ApiError
     */
    public resendInviteEmail(
        userId: string,
        email: string,
    ): CancelablePromise<ControllerResponse_number_or_null_> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/admin/resend_invite_email/{userId}',
            path: {
                'userId': userId,
            },
            query: {
                'email': email,
            },
        });
    }
    /**
     * @param requestBody
     * @returns ControllerResponse_boolean_ Ok
     * @throws ApiError
     */
    public createNewClient(
        requestBody: NewClient,
    ): CancelablePromise<ControllerResponse_boolean_> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/admin/new_client',
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * @param requestBody
     * @returns ControllerResponse_DebugProperty_Array_ Ok
     * @throws ApiError
     */
    public debugProperties(
        requestBody: {
            ids: Array<string>;
        },
    ): CancelablePromise<ControllerResponse_DebugProperty_Array_> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/admin/debug_properties',
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * @param userId
     * @returns ControllerResponse_Subscription_Array_ Ok
     * @throws ApiError
     */
    public getCustomerSubscriptions(
        userId: string,
    ): CancelablePromise<ControllerResponse_Subscription_Array_> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/admin/subscriptions/{userId}',
            path: {
                'userId': userId,
            },
        });
    }
    /**
     * @param userId
     * @returns ControllerResponse_Subscription_Array_ Ok
     * @throws ApiError
     */
    public getChildrenSubscriptions(
        userId: string,
    ): CancelablePromise<ControllerResponse_Subscription_Array_> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/admin/child_subscriptions/{userId}',
            path: {
                'userId': userId,
            },
        });
    }
    /**
     * @param userId
     * @param subscriptionId
     * @returns ControllerResponse_Subscription_or_null_ Ok
     * @throws ApiError
     */
    public closeChildAccount(
        userId: string,
        subscriptionId: string,
    ): CancelablePromise<ControllerResponse_Subscription_or_null_> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/admin/close_child_account/{userId}',
            path: {
                'userId': userId,
            },
            query: {
                'subscriptionId': subscriptionId,
            },
        });
    }
    /**
     * @param userId
     * @param subscriptionId
     * @returns ControllerResponse_Subscription_or_null_ Ok
     * @throws ApiError
     */
    public keepChildAccount(
        userId: string,
        subscriptionId: string,
    ): CancelablePromise<ControllerResponse_Subscription_or_null_> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/admin/keep_child_account/{userId}',
            path: {
                'userId': userId,
            },
            query: {
                'subscriptionId': subscriptionId,
            },
        });
    }
    /**
     * @param days
     * @returns ControllerResponse_AdminApiUsage_Array_ Ok
     * @throws ApiError
     */
    public getApiUsage(
        days: number,
    ): CancelablePromise<ControllerResponse_AdminApiUsage_Array_> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/admin/api_usage',
            query: {
                'days': days,
            },
        });
    }
    /**
     * @returns ControllerResponse_AdminInPortfolioStats_Array_ Ok
     * @throws ApiError
     */
    public getInPortfolioStats(): CancelablePromise<ControllerResponse_AdminInPortfolioStats_Array_> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/admin/in_portfolio_stats',
        });
    }
    /**
     * @param organizationId
     * @returns ControllerResponse_GroupAttributes_Array_ Ok
     * @throws ApiError
     */
    public getOrganizationGroups(
        organizationId: number,
    ): CancelablePromise<ControllerResponse_GroupAttributes_Array_> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/admin/organization/{organizationId}/group',
            path: {
                'organizationId': organizationId,
            },
        });
    }
    /**
     * @param organizationId
     * @param requestBody
     * @returns any Ok
     * @throws ApiError
     */
    public createOrganizationGroup(
        organizationId: number,
        requestBody: CreateGroupAttributes,
    ): CancelablePromise<{
        data: GroupAttributes;
    }> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/admin/organization/{organizationId}/group',
            path: {
                'organizationId': organizationId,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * @param organizationId
     * @returns any Ok
     * @throws ApiError
     */
    public createOrganizationGroupDefault(
        organizationId: number,
    ): CancelablePromise<{
        data: GroupAttributes;
    }> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/admin/organization/{organizationId}/groupdefault',
            path: {
                'organizationId': organizationId,
            },
        });
    }
    /**
     * @param groupId
     * @param requestBody
     * @returns any Ok
     * @throws ApiError
     */
    public updateOrganizationGroup(
        groupId: number,
        requestBody: UpdateGroupAttributes,
    ): CancelablePromise<{
        data: GroupAttributes;
    }> {
        return this.httpRequest.request({
            method: 'PATCH',
            url: '/admin/group/{groupId}',
            path: {
                'groupId': groupId,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * @param groupId
     * @returns void
     * @throws ApiError
     */
    public deleteOrganizationGroup(
        groupId: number,
    ): CancelablePromise<void> {
        return this.httpRequest.request({
            method: 'DELETE',
            url: '/admin/group/{groupId}',
            path: {
                'groupId': groupId,
            },
        });
    }
    /**
     * @param groupId
     * @returns any Ok
     * @throws ApiError
     */
    public setExternal(
        groupId: number,
    ): CancelablePromise<{
        data: boolean;
    }> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/admin/group/{groupId}/external',
            path: {
                'groupId': groupId,
            },
        });
    }
    /**
     * @param groupId
     * @param requestBody
     * @returns any Ok
     * @throws ApiError
     */
    public createOrganizationGroupUser(
        groupId: number,
        requestBody: {
            user_ids: Array<string>;
        },
    ): CancelablePromise<{
        data: Array<Pick_UserAttributes_id_or_email_or_created_on_or_organization_id_or_given_name_or_family_name_or_picture_or_group_id_>;
    }> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/admin/group/{groupId}/groupuser',
            path: {
                'groupId': groupId,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * @param groupId
     * @param userToRemoveId
     * @returns void
     * @throws ApiError
     */
    public deleteOrganizationGroupUser(
        groupId: number,
        userToRemoveId: string,
    ): CancelablePromise<void> {
        return this.httpRequest.request({
            method: 'DELETE',
            url: '/admin/group/{groupId}/groupuser/{userToRemoveId}',
            path: {
                'groupId': groupId,
                'userToRemoveId': userToRemoveId,
            },
        });
    }
    /**
     * @returns any
     * @throws ApiError
     */
    public clearCache(): CancelablePromise<any> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/admin/clear_cache',
        });
    }
    /**
     * @param state
     * @returns any
     * @throws ApiError
     */
    public clearCacheByState(
        state: string,
    ): CancelablePromise<{
        deleted: number;
    }> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/admin/clear_cache_by_state',
            query: {
                'state': state,
            },
        });
    }
    /**
     * @returns ControllerResponse_TemplateAIAttributes_Array_ Ok
     * @throws ApiError
     */
    public getAllReportTemplates(): CancelablePromise<ControllerResponse_TemplateAIAttributes_Array_> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/admin/report/templates',
        });
    }
    /**
     * @param requestBody
     * @returns ControllerResponse_TemplateAIAttributes_ Ok
     * @throws ApiError
     */
    public createReportTemplate(
        requestBody: {
            tags?: Array<string>;
            prompt: string;
            name: string;
        },
    ): CancelablePromise<ControllerResponse_TemplateAIAttributes_> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/admin/report/templates',
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * @param templateId
     * @returns ControllerResponse_TemplateAIAttributes_ Ok
     * @throws ApiError
     */
    public getReportTemplateById(
        templateId: number,
    ): CancelablePromise<ControllerResponse_TemplateAIAttributes_> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/admin/report/templates/{templateId}',
            path: {
                'templateId': templateId,
            },
        });
    }
    /**
     * @param templateId
     * @param requestBody
     * @returns ControllerResponse_TemplateAIAttributes_ Ok
     * @throws ApiError
     */
    public updateReportTemplate(
        templateId: number,
        requestBody: {
            tags?: Array<string>;
            prompt?: string;
            name?: string;
        },
    ): CancelablePromise<ControllerResponse_TemplateAIAttributes_> {
        return this.httpRequest.request({
            method: 'PATCH',
            url: '/admin/report/templates/{templateId}',
            path: {
                'templateId': templateId,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * @param templateId
     * @returns ControllerResponse_TemplateAIAttributes_ Ok
     * @throws ApiError
     */
    public deleteReportTemplate(
        templateId: number,
    ): CancelablePromise<ControllerResponse_TemplateAIAttributes_> {
        return this.httpRequest.request({
            method: 'DELETE',
            url: '/admin/report/templates/{templateId}',
            path: {
                'templateId': templateId,
            },
        });
    }
    /**
     * @param requestBody
     * @returns any Ok
     * @throws ApiError
     */
    public adminPreviewDataset(
        requestBody: {
            userId: string;
            payload: DatasetPayload;
        },
    ): CancelablePromise<Array<Array<(string | number | boolean) | null>>> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/admin/export/preview',
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * @param requestBody
     * @returns any Created
     * @throws ApiError
     */
    public adminSendDatasetEmail(
        requestBody: {
            format: 'csv' | 'jsonl';
            name: string;
            payload: DatasetPayload;
            userId: string;
        },
    ): CancelablePromise<any> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/admin/send_email',
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * @param organizationId
     * @param formData
     * @returns any Created
     * @throws ApiError
     */
    public createSso(
        organizationId: number,
        formData: {
            certificateFile: Blob;
            connectionName: string;
            issuer: string;
            signinUrl: string;
            domains: string;
        },
    ): CancelablePromise<any> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/admin/organization/{organizationId}/sso',
            path: {
                'organizationId': organizationId,
            },
            formData: formData,
            mediaType: 'multipart/form-data',
        });
    }
    /**
     * @param organizationId
     * @returns ControllerResponse__enabled_boolean__ Ok
     * @throws ApiError
     */
    public viewSso(
        organizationId: number,
    ): CancelablePromise<ControllerResponse__enabled_boolean__> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/admin/organization/{organizationId}/sso',
            path: {
                'organizationId': organizationId,
            },
        });
    }
    /**
     * @param organizationId
     * @param requestBody
     * @returns ControllerResponse__enabled_boolean__ Ok
     * @throws ApiError
     */
    public setSsoStatus(
        organizationId: number,
        requestBody: {
            enabled: boolean;
        },
    ): CancelablePromise<ControllerResponse__enabled_boolean__> {
        return this.httpRequest.request({
            method: 'PATCH',
            url: '/admin/organization/{organizationId}/set_sso_status',
            path: {
                'organizationId': organizationId,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }
}
